export default __webpack_public_path__ + "static/media/zero-sugar-000000.3aa04367.png";